/**
 * Brand icon — navy rounded square + gold S with pin drop.
 * WebP (with PNG fallback), tiny (~2KB). Mobile gets an even smaller source.
 */
const ICON_WEBP = "/brand-icon.webp";
const ICON_WEBP_SM = "/brand-icon-sm.webp";
const ICON_PNG = "/brand-icon.png";

export default function BrandMark({ size = 40, className = "" }) {
  const px = Math.round(size);
  return (
    <div
      className={`relative overflow-hidden rounded-[22%] ${className}`}
      style={{ width: size, height: size }}
      aria-label="Street Eats Rewards"
    >
      <picture>
        <source
          type="image/webp"
          srcSet={`${ICON_WEBP_SM} 96w, ${ICON_WEBP} 120w`}
          sizes="48px"
        />
        <img
          src={ICON_PNG}
          alt="Street Eats Rewards"
          width={px}
          height={px}
          decoding="async"
          className="absolute inset-0 w-full h-full"
          style={{
            objectFit: "contain",
            transform: "scale(1.6)",
            transformOrigin: "center center",
          }}
        />
      </picture>
    </div>
  );
}
